export default __webpack_public_path__ + "static/media/carrousel-sncc-2grau.bb55be81.png";